import { resolveImagePath } from '@/utils/imageMap.ts';

interface TrustedWorkSectionProps {
  title: string;
  description: string;
  callToAction: string;
  phoneNumber: string;
  beforeImage: string;
  afterImage: string;
  beforeImageAlt: string;
  afterImageAlt: string;
}

export function TrustedWorkSection({
  title,
  description,
  callToAction,
  phoneNumber,
  beforeImage,
  afterImage,
  beforeImageAlt,
  afterImageAlt
}: TrustedWorkSectionProps) {
  return (
    <section className="py-16 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Text content */}
          <div className="order-2 lg:order-1 space-y-6">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight">
              {title}
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed">
              {description}
            </p>
            <div className="text-lg text-gray-700">
              <span>{callToAction} </span>
              <a 
                href={`tel:${phoneNumber}`} 
                className="font-bold text-blue-600 hover:text-blue-800 transition-colors"
              >
                {phoneNumber}
              </a>
              <span>.</span>
            </div>
          </div>

          {/* Right side - Before/After images */}
          <div className="order-1 lg:order-2 relative">
            <div className="grid grid-cols-2 gap-4">
              {/* Before image */}
              <div className="relative">
                <img
                  src={resolveImagePath(beforeImage)}
                  alt={beforeImageAlt}
                  className="w-full h-64 lg:h-80 object-cover rounded-lg shadow-lg"
                />
                <div className="absolute bottom-3 left-3 bg-black bg-opacity-75 text-white px-3 py-1 rounded text-sm font-medium">
                  Before
                </div>
              </div>
              
              {/* After image */}
              <div className="relative">
                <img
                  src={resolveImagePath(afterImage)}
                  alt={afterImageAlt}
                  className="w-full h-64 lg:h-80 object-cover rounded-lg shadow-lg"
                />
                <div className="absolute bottom-3 left-3 bg-black bg-opacity-75 text-white px-3 py-1 rounded text-sm font-medium">
                  After
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}